/**************************************************************************************************/
/*   File: /src/app/shared/services/index.ts                                                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday February 18th 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
export * from './authorization/index';
export * from './download/index';
export * from './dossier/index';

export * from './language/index';
export * from './utils/index';
export * from './file/index'; 

export * from './utils/header.service';